import { gql } from '@apollo/client'
import { GROUPED_PRIORITY_COMPLIANCE_FRAGMENT } from '../fragments/GroupedPriorityCompliance'

export const PICOS_GROUPED_PRIORITIES_COMPLIANCE = gql`
  query PicOSGroupedPrioritiesCompliance(
    $input: PicOSAllPrioritiesComplianceInput!
  ) {
    picosGroupedPrioritiesCompliance(input: $input) {
      count
      hasMore
      results {
        ...PicOSGroupedPriorityCompliance
      }
    }
  }
  ${GROUPED_PRIORITY_COMPLIANCE_FRAGMENT}
`
